// extracted by mini-css-extract-plugin
module.exports = {"container":"IconField_container__15dqT","icon":"IconField_icon__33D-O","spanText":"IconField_spanText__2hU9A"};